module.exports = __webpack_public_path__ + "media/Zusammen sind wir stark.cda2d064.wav";